import { format } from "date-fns";
import { CollapsibleSection } from "@/bizminer/Admin/InsightRequests/_components/CollapsibleSection.tsx";
import type { BizminerAdminInsightRequestDetail } from "@/types/serializers";

const WebhookEventItem = ({
  event,
}: {
  event: BizminerAdminInsightRequestDetail["webhook_events"][number];
}) => (
  <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
    <div className="flex items-center gap-3">
      <span className="font-mono text-xs bg-secondary px-2 py-1 rounded">
        {event.event_type}
      </span>
      <span className="text-xs text-muted-foreground">{event.status}</span>
    </div>
    <span className="text-xs text-muted-foreground">
      {format(new Date(event.created_at), "MMM d, HH:mm:ss")}
    </span>
  </div>
);
export const WebhookEventsSection = ({
  events,
}: {
  events: BizminerAdminInsightRequestDetail["webhook_events"];
}) => (
  <CollapsibleSection
    title="Webhook Events"
    description={`${events.length} event(s) received`}
  >
    {events.length === 0 ? (
      <p className="text-muted-foreground text-sm">
        No webhook events received yet.
      </p>
    ) : (
      <div className="space-y-2">
        {events.map((event) => (
          <WebhookEventItem key={event.id} event={event} />
        ))}
      </div>
    )}
  </CollapsibleSection>
);
